/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 13:58:42
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { chunk, flatten } from "lodash";
import { addBrInStr, toVisualThousands } from "../utils";
import { labelFont, yAxisLabelColor } from "../visualConfig";

const createGrid = (list = []) => {
  const len = list.length;
  const width = (1210 - 80) / len;
  const result = list.map((_, index) => {
    const _index = index * 2;
    const _width = width;
    const _left = index * width + 80
    return [
      {
        id: _index,
        top: 50,
        width: _width,
        left: _left,
        bottom: '60%',
        containLabel: false,
      },
      {
        id: _index + 1,
        top: '60%',
        width: _width,
        left: _left,
        bottom: 50,
        containLabel: false,
      }
    ]
  });

  return flatten(result);
};

const createXAxis = (list = []) => {
  const result = list.map((item, index) => {
    const _index = index * 2;

    return [
      {
        name: [
          `{title|${item.name}}`,
          `{subTitle|${addBrInStr(item.subName, 11)}}`
        ].join('\n'),
        nameLocation: 'center',
        nameTextStyle: {
          rich: {
            title: {
              fontSize: 18,
              color: '#000',
              fontWeight: 'bold',
            },
            subTitle: {
              width: 100,
              fontSize: 13,
              color: '#000',
              padding: [5, 0, 0, 0]
            }
          }
        },
        gridIndex: _index,
        type: 'category',
        axisLabel: {
          show: false,
        },
        splitLine: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
      },
      {
        gridIndex: _index + 1,
        type: 'category',
        axisLabel: {
          show: false,
        },
        splitLine: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
      }
    ]
  });

  return flatten(result);
}

const createYAxis = (list = []) => {
  const ddd = list.map(item => [Math.max(...item.list0), Math.max(...item.list1)]);
  const [topMax, bottomMax] = ddd.reduce((acc, curr) => {
    return [Math.max(acc[0], curr[0]), Math.max(acc[1], curr[1])]
  }, [0, 0])

  const result = list.map((item, index) => {
    const _index = index * 2;

    return [
      {
        type: 'value',
        gridIndex: _index,
        // show: index === 0,
        name: index === 0 ? '话题点   ' : '',
        nameLocation: 'start',
        nameTextStyle: {
          align: 'right',
          fontSize: 18,
          fontWeight: 'bold',
          color: '#000',
        },
        bottom: 0,
        max: topMax,
        axisLabel: { show: index === 0, ...yAxisLabelColor },
        splitLine: { show: true },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
      },
      {
        type: 'value',
        gridIndex: _index + 1,
        name: index === 0 ? '主要    \n关键词   ' : '',
        nameLocation: 'end',
        nameTextStyle: {
          align: 'right',
          fontSize: 18,
          fontWeight: 'bold',
          color: '#000',
        },
        max: bottomMax,
        axisLabel: { show: index === 0, ...yAxisLabelColor },
        splitLine: { show: true },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
      },
    ]
  });

  return flatten(result);
}

const createSeries = (list = [], label = [], color = []) => {
  console.log(list)
  const labelGroup = chunk(label, 2);

  const result = list.map((item, index) => {
    const _index = index * 2;
    return [
      {
        xAxisIndex: _index,
        yAxisIndex: _index,
        type: 'bar',
        barMaxWidth: 30,
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
        ...labelFont,
        },
        data: item.list0.map((ele, i) => ({
          name: labelGroup[0][i],
          value: ele,
          itemStyle: {
            color: color[i]
          }
        })),
      },
      {
        xAxisIndex: _index + 1,
        yAxisIndex: _index + 1,
        type: 'bar',
        barMaxWidth: 30,
        label: {
          show: true,
          position: 'bottom',
          color: '#f00',
          formatter: (ele) => toVisualThousands(ele.value),
        ...labelFont,
        },
        data: item.list1.map((ele, i) => ({
          name: labelGroup[1][i],
          value: ele,
          itemStyle: {
            color: color[item.list1.length - i - 1]
          }
        })),
      }
    ]
  });

  return flatten(result);
}

export default  ({ label = [], list = [], color = [] }) => {
  return {
    title: [{
      text: '话题点修复文章DB值及内容条数',
      textAlign: 'center',
      top: 10,
      testStyle: {
        color: '#000',
      }
    }, {
      text: '话题点负面文章DB值及内容条数',
      textAlign: 'center',
      bottom: 10,
      testStyle: {
        color: '#000',
      }
    }],
    legend: {
      // data: label.map(item => ({ name: item })),
    },
    tooltip: {},
    grid: createGrid(list),
    xAxis: createXAxis(list),
    yAxis: createYAxis(list),
    series: createSeries(list, label, color),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P21/chart.js